var exports = {
  "x": "button__1uQE7N",
  "K": "icon__roGhs9",
};

module.exports = exports;
